module.exports = __webpack_public_path__ + "static/media/stake.78f735d2.svg";